<div class="search-container-details stats-border-radius">
    <div class="table-title-container">
        <span class="table-title">{{ title }} <span *ngIf="priority">-</span> {{ priority }}</span>

        <span class="table-sub-title">{{ subTitle }}</span>
    </div>
    <div class="inbox-search-container">
        <cll-form-field label="Type a keyword...">
            <cll-icon cllPrefix>search</cll-icon>
            <input [formControl]="searchControl"
                   cllFormInput
                   type="text">

            @if (searchControl.value) {
                <button (click)="searchControl.reset()"
                        cll-icon-button
                        cllTooltip="Clear search query"
                        cllSuffix>
                    <cll-icon>clear</cll-icon>
                </button>
            }
        </cll-form-field>
    </div>
</div>

<div class="stats-table-container">
    <table class="cll-table stats-table">
        <thead class="sticky-table-top">
        <tr>
            <th>Reference</th>
            <th>Postcode</th>
            <th>Support required</th>
            <th>Publish date</th>
            <th>Timer</th>
            <th>Responses</th>
        </tr>
        </thead>
        <tbody>
            @let timeDifferences = (timeDifferences$ | async);
            @for (_package of (filteredPackages$ | async); track _package.id) {
                <tr class="stats-row" (click)="openPackageInNewTab(_package.id)">
                    <td>{{ _package.reference }}</td>
                    <td class="nowrap">{{ _package.post_code || '-' }}</td>
                    <td>{{ _package.support_required }}</td>
                    <td>
                        @if (_package.publish === 'draft') {
                            Draft
                        } @else if (_package.publish === 'immediately') {
                            @if (_package.publish_at !== null) {
                                {{ _package.publish_at | appDate: 'dd/MM/yyyy HH:mm' }}
                            } @else {
                                {{ _package.created_at | appDate: 'dd/MM/yyyy HH:mm' }}
                            }
                        } @else {
                            {{ _package.publish_at | appDate: 'dd/MM/yyyy HH:mm' }}
                        }
                    </td>
                    <td>
                        @if (_package.broadcast_at !== null && _package.id && timeDifferences) {
                            {{ timeDifferences?.get(_package.id) }}
                        } @else {
                            Not Started
                        }
                    </td>
                    <td>{{ _package.response_count }}</td>
                </tr>
            }
        </tbody>
    </table>
</div>
